var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['rotating-backlight', { 'rotating-backlight-disabled': _vm.noData }],style:(_vm.borderStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }